import { __assign } from "tslib";
import React from 'react';
import { Slider } from '@tencent/tea-component';
export function BuySlider(props) {
    return (React.createElement("div", { className: "tea-for-buy" },
        React.createElement("div", { className: "tea-form" },
            React.createElement(Slider, __assign({}, props)))));
}
//# sourceMappingURL=BuySlider.js.map